'use strict';

angular.module('observationModule', [
]);